export class Liquidacion {
  idliquida?: string;
  tot_salcarga?: number;
  tot_entradacarga?: number;
  tot_presdevo?: number;
  totalcarga?: number;
  idpersonal?: any;
  fecha?: string;
  hora?: string;
  placa?: string;
  devoglp?: number;
  cant_venta?: number;
  tot_venta?: number;
  cobro_credito?: number;
  otorga_credito?: number;
  gasto?: number;
  tarjeta?: number;
  billeteraelec?: number;
  fise?: number;
  promo_salida?: string;
  promo_devo?: string;
  venta_promo?: string;
  neto?: number;
  estado?: string;
  entrega?: number;
  deposito?: number;
  efectivo?: number;
  diferencia?: number;
  cerrada?: boolean;
  fecha_cierre?: string;

  constructor() { }
}
